import { SelectWithSpinAndCustomMaxTag } from "@src/components/select/SelectWithCustomMaxTag";
import { FilterFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import { Form, FormInstance } from "antd";
import React from "react";
import { generalStyleFormExtraItem } from "../modal-content";

export const ExtraPlatform: React.FC<{ form: FormInstance }> = ({ form }) => {
  const platformOptionsWatch = Form.useWatch(FilterFormFieldsEnum.PLATFORM_OPTIONS, form);
  const isAmaAppLoading = Form.useWatch(FilterFormFieldsEnum.IS_AMA_APP_LOADING, form);

  return (
    <Form.Item
      {...generalStyleFormExtraItem}
      label="Platform"
      name={FilterFormFieldsEnum.EXTRA_PLATFORM}
      required
      rules={[
        {
          required: true,
          message: "Please select platform",
        },
      ]}
    >
      <SelectWithSpinAndCustomMaxTag
        loading={isAmaAppLoading}
        allowClear
        placeholder="Platform"
        options={platformOptionsWatch ?? []}
        mode="multiple"
      />
    </Form.Item>
  );
};
